export default {
    delete: {
        title: 'Confirmar Exclusão ?',
        text: 'Tem certeza que deseja realizar a exclusão do registro {name} ?',
        success: 'Registro excluído.',
    },

    restore: {
        title: 'Confirmar Restauração ?',
        text: 'Tem certeza que deseja restaurar o registro {name} ?',
        success: 'Registro restaurado.',
    },
}
